import React from 'react';
import '../styles/content.scss';

const Content = ({ type, children }) => <section className={`${type ? type : ''}content`}>{children}</section>;

export default Content;
